/*
  Registry of available game manager plugins.

  To add a new game:
    1. Create a GameManager class
    2. Implement IGameManager instance methods
    3. Implement required static methods from GameManagerClass
    4. Add it to GameRegistry
*/
import { MatchPlay_GameManager } from "./MatchPlay_GameManager";
import { StrokePlay_GameManager } from "./StrokePlay_GameManager";
import { FourBall_GameManager } from "./FourBall_GameManager";
export const GameManagerRegistry = {
    'match play': MatchPlay_GameManager,
    'stroke play': StrokePlay_GameManager,
    'four ball': FourBall_GameManager,
};
//# sourceMappingURL=GameManagerRegistry.js.map